import React from "react";
import Form, { SimpleItem, GroupItem, Label, ButtonItem } from "devextreme-react/form";
import { Button } from "devextreme-react";
import { DataGrid, Column, Pager, Paging } from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import api from "../../api-axios";
import notify from "devextreme/ui/notify";
import UserInfo from "../../UserInfo";
import PaginaToolbar from "../../components/PaginaToolbar";
import { TabPanel, Item } from "devextreme-react/tab-panel";
import ShowError from "../../AppServices";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";

export default class SimulacoesComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state =
    {
      _uiCarregando: "",
      _uiMostrarBotaoAbandonar: false,
      _uiPopupParams: false,
      fce: "",
      fceDecimais: 0,
      fcl: "",
      fclDecimais: 0,
      vve: "",
      vvt: "",
      vvi: "",
      dataSource: [],
      exportarCompletoDataSource: []
    };
    this.renderCartografiasText = this.renderCartografiasText.bind(this);
    this._gridInstance = React.createRef();
    this.simularIptu = this.simularIptu.bind(this);
    this.acompanharSimulacao = this.acompanharSimulacao.bind(this);
    this.buscarItens = this.buscarItens.bind(this);


  }

  componentDidMount() {

    this.setState({ _uiCarregando: true });

    api
      .get(`simulacaoiptu/start/${UserInfo.getPrefeitura()}`)
      .then(resp => {
        this.setState({ ...resp.data, _uiCarregando: false });
      })
      .catch(error => {

        if (error && error.response && error.response.data) {
          ShowError(error.response.data.erros);
        }
        else {
          notify("Erro ao exportar completo", "error");
        }

      });

  }

  buscarItens() {

    if (this.statusInterval) {
      clearInterval(this.statusInterval);
    }

    this.setState({ _uiCarregando: `Obtendo itens da Simulação ${this.state.filtro.simulacaoId}` });

    api
      .get(`simulacaoiptu/buscarItens/${UserInfo.getPrefeitura()}/${this.state.filtro.simulacaoId}`)
      .then(resp => {
        const data = resp.data;
        this.setState({ _uiCarregando: "", dataSource: data.itens });
      });
  }

  acompanharSimulacao(simulacaoId) {

    const simulacaoLocalId = simulacaoId ?? this.state.filtro.simulacaoId;

    if (this.statusInterval) {
      clearInterval(this.statusInterval);
    }

    this.setState({ _uiCarregando: `Acompanhando Simulação ${simulacaoLocalId}`, _uiMostrarBotaoAbandonar: true });

    this.statusInterval = setInterval(() => {
      api
        .get(`simulacaoiptu/status/${UserInfo.getPrefeitura()}/${simulacaoLocalId}`)
        .then(resp => {
          if (!this.statusInterval) {
            return;
          }
          const data = resp.data;
          if (data.qtdePendente === 0) {
            clearInterval(this.statusInterval);
            this.buscarItens();
          }
          else {
            this.setState({
              _uiCarregando: data.msgStatus
            });
          }


        });
    }, 3000);

  }

  abandonarSimulacao() {
    if (this.statusInverval) {
      clearInterval(this.statusInverval);
    }
    this.setState({ _uiCarregando: "", _uiMostrarBotaoAbandonar: false })
  }

  exportarCompleto() {

    var request = { ...this.state };

    api
      .post(`simulacaoiptu/gerar_exportacao/${UserInfo.getPrefeitura()}/${this.state.anoAnterior}`, request)
      .then(resp => {
        this.setState({ exportarCompletoDataSource: resp.data });
      })
      .catch(error => {

        if (error && error.response && error.response.data) {
          ShowError(error.response.data.erros);
        }
        else {
          notify("Erro ao exportar completo", "error");
        }

      });
  }

  simularIptu() {
    var request = { ...this.state };
    
    api
      .post(`simulacaoiptu/${UserInfo.getPrefeitura()}`, request)
      .then(resp => {
        this.setState({ filtro: { simulacaoId: resp.data.simulacaoId } });
        this.acompanharSimulacao(resp.data.simulacaoId);
      })
      .catch(error => {
    
        notify("Erro ao calcular iptu", "error");
      });


  }

  renderCartografiasText() {
    return (
      <p>
        <strong>
          Para incluir várias quadras e cartografias, separe os valores por vírgula (,)
        </strong>
      </p>
    );
  }

  render() {

    if (this.state._uiCarregando != "") {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >

            <div style={{ flex: 1 }}>
              <LoadIndicator width={60} height={60} />
            </div>
            <div style={{ flex: 1, marginTop: 15 }}>{this.state._uiCarregando}</div>
            <div style={{ flex: 1, marginTop: 15 }}>
              {
                this.state._uiMostrarBotaoAbandonar && <Button
                  width={250}
                  text="Abandonar Simulação"
                  onClick={() => this.abandonarSimulacao()}
                />
              }
            </div>

          </div>
        </div>
      );
    }

    return (



      <div className={"content-block dx-card responsive-paddings"}>
        <TabPanel
          selectedIndex={this.state.index}
          onTitleClick={(e) => this.setState({ index: e.itemIndex })}
        >
          <Item title="SIMULAÇÃO">
            <div style={{ padding: "25px" }}>
              <Form formData={this.state} colCount={6} labelLocation={"top"}>


                <GroupItem colSpan={6} colCount={6} caption="Filtros">
                  <SimpleItem dataField="nomeContribuinte" colSpan={6}>
                    <Label text="Nome do Contribuinte" />
                  </SimpleItem>
                  <SimpleItem dataField="quadras" colSpan={2}>
                    <Label text="Quadras" />
                  </SimpleItem>
                  <SimpleItem dataField="bairros" colSpan={2}>
                    <Label text="Bairros" />
                  </SimpleItem>
                  <SimpleItem dataField="setor" colSpan={1}>
                    <Label text="Setor" />
                  </SimpleItem>
                  <SimpleItem dataField="simulacaoId" colSpan={1} editorType={"dxNumberBox"}>
                    <Label text="Cód. Simulação" />
                  </SimpleItem>
                  <SimpleItem dataField="cartografias" colSpan={2} helpText="Para incluir várias quadras e cartografias, separe os valores por vírgula (,)">
                    <Label text="Cartografias" />
                  </SimpleItem>
                  <SimpleItem dataField="inscricoes" colSpan={2}>
                    <Label text="Incrições" />
                  </SimpleItem>
                  <SimpleItem dataField="tipoValor" colSpan={2} helpText="Em branco - PGV Oficial, 'B' - Baixo, 'M' - Médio, 'A' - Alto, ">
                    <Label text="Tipo PGV" />
                  </SimpleItem>
                   <SimpleItem dataField="tagId" colSpan={2}>
                    <Label text="Tag ID" />
                  </SimpleItem>
                  <SimpleItem
                    dataField="naoSimularIgnorados"
                    colSpan={6}
                    editorType={"dxCheckBox"}
                  >
                    <Label text="Não simular IGNORADOS" />
                  </SimpleItem>
                  <SimpleItem
                    dataField="naoSimularSemDocumento"
                    colSpan={6}
                    editorType={"dxCheckBox"}
                  >
                    <Label text="Não simular contribuintes sem documento" />
                  </SimpleItem>
                </GroupItem>
              </Form>
              <div
                style={{
                  display: "flex",
                  marginTop: "25px",
                  justifyContent: "center",
                  alignContent: "center",
                  justifyItems: "center",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <Button
                  icon="columnchooser"
                  text="Simular"
                  type="normal"
                  width={120}
                  onClick={() => this.simularIptu()}
                />
                <Button
                  icon="print"
                  width={120}
                  text="Imprimir"
                  type="success"
                  onClick={() => alert("Imprimir")}
                />
                {
                  UserInfo.possuiPerfil("trimap") && <Button
                    icon="fields"
                    width={180}
                    text="Fórmulas e limites"
                    type="normal"
                    onClick={() => this.setState({ _uiPopupParams: true })}
                  />}

              </div>
              <br />
              <PaginaToolbar>
                <DataGrid
                  ref={(grid) => (this._gridInstance = grid)}
                  dataSource={this.state.dataSource}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  remoteOperations={true}
                  wordWrapEnabled={true}
                  headerFilter={{ visible: false }}
                  filterRow={{ visible: true }}
                >
                  <Column dataField={"sucesso"} alignment={"center"} caption={"OK"} width={100} />
                  <Column dataField={"imovelId"} caption={"Imovel"} alignment={"center"} width={120} />
                  <Column dataField={"natureza"} caption={"Natureza"} alignment={"center"} width={120} />
                  <Column dataField={"situacao"} caption={"Situação"} width={100} />
                  <Column dataField={"cartografia"} caption={"Cartografia"} width={200} />
                  
                  <Column dataField={"BairroId"} caption={"Cód. Bairro"} visible={false} />
                  <Column dataField={"bairro"} caption={"Bairro"} />
                  
                  <Column dataField={"contribuinteId"} caption={"Cód. Contribuinte"} visible={false} />
                  <Column dataField={"contribuinte"} caption={"Nome Contribuinte"} visible={false}/>
                  <Column dataField={"contribuinteComId"} caption={"Contribuinte"} />
                  <Column dataField={"cpfCnpj"} caption={"CPF/CNPJ"} visible={false}/>
                  
                  <Column dataField={"logradouroId"} caption={"Cód. Logradouro"} visible={false}/>
                  <Column dataField={"logradouro"} caption={"Logradouro"} visible={false}/>
                  <Column dataField={"segmento"} caption={"Segmento"} visible={false}/>

                  <Column dataField={"areaLote"} caption={"Área Lote"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} />
                  <Column dataField={"areaPrivada"} caption={"Área Privada"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2}  visible={false}/>
                  <Column dataField={"areaComum"} caption={"Área Comum"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2}  visible={false}/>

                  <Column dataField={"valorM2Terreno"} caption={"Vr. m² Terreno (R$)"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} />

                  <Column dataField={"fctSoma"} caption={"Soma FCL"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false} />
                  <Column dataField={"fctQuantidade"} caption={"Qtde. FCL"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.inteiroSemPonto} visible={false} />
                  <Column dataField={"fcl"} caption={"FCL"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n6} />
                  <Column dataField={"valorTerreno"} caption={"VVT"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} />


                  <Column dataField={"areaEdificacao"} caption={"Área Edificada"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} />
                  <Column dataField={"valorM2Edificado"} caption={"Vr. m² Edificado (R$)"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} />

                  <Column dataField={"fceSoma"} caption={"Soma FCE"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false} />
                  <Column dataField={"fceQuantidade"} caption={"Qtde. FCE"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.inteiroSemPonto} visible={false} />
                  <Column dataField={"fce"} caption={"FCE"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n6} />
                  <Column dataField={"valorEdificacao"} caption={"VVE"} width={120} dataType={"number"} format={uiInfo.formatoNumerico.n2} />

                  <Column dataField={"valorVenal"} caption={"VVI"} width={120} dataType={"number"} format={uiInfo.formatoNumerico.n2} />
                  <Column dataField={"aliquota"} caption={"Alíquota"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} />
                  <Column dataField={"imposto"} caption={"Imposto (R$)"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} />
                  <Column dataField={"saldoAnterior"} caption={"Saldo IPTU Anterior (R$)"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false}/>
                  
                  <Column dataField={"iptuAnteriorInfo.exercicio"} caption={"Exercicio IPTU Anterior"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false}/>
                  <Column dataField={"iptuAnteriorInfo.valorVenal"} caption={"VVI IPTU Anterior"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false}/>
                  <Column dataField={"iptuAnteriorInfo.aliquota"} caption={"Aliq. IPTU Anterior (%)"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false}/>
                  <Column dataField={"iptuAnteriorInfo.valorIptu"} caption={"IPTU Anterior (R$)"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false}/>
                  <Column dataField={"iptuAnteriorInfo.diferenca"} caption={"Diferença (R$)"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false}/>
                  <Column dataField={"iptuAnteriorInfo.diferencaAbsoluta"} caption={"Diferença Abs. (R$)"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false}/>

                  <Column dataField={"msgErro"} caption={"Erro"} />

                  <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                  />
                </DataGrid>
              </PaginaToolbar>
            </div>
          </Item>
          <Item title="EXPORTAÇÃO COMPLETA">
            <div style={{ padding: "25px" }} >
              <Form formData={this.state} colCount={3} labelLocation={"top"}>
                <GroupItem colSpan={3} colCount={6} caption="Gerar exportação">
                  <SimpleItem dataField="anoAnterior" colSpan={2}>
                    <Label text="Ano anterior" />
                  </SimpleItem>
                  <ButtonItem
                    colSpan={1}
                    horizontalAlignment={"center"}
                    verticalAlignment={"bottom"}
                    buttonOptions={{
                      width: "100px",
                      type: "normal",
                      text: "Gerar",
                      onClick: () => this.exportarCompleto()
                    }}
                  />
                </GroupItem>
              </Form>
              <br />
              <PaginaToolbar>
                <DataGrid
                  ref={(grid) => (this._gridInstance = grid)}
                  dataSource={this.state.exportarCompletoDataSource}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  remoteOperations={true}
                  wordWrapEnabled={true}
                  headerFilter={{ visible: false }}
                  filterRow={{ visible: true }}
                  columnAutoWidth={true}
                >
                  <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                  />
                </DataGrid>
              </PaginaToolbar>

            </div>
          </Item>
        </TabPanel>
        <Popup
          visible={this.state._uiPopupParams}
          onHiding={this.hideInfo}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"500"}
          height={"550"}
          title="Parâmetros"
        >
          <ScrollView showScrollbar="always">
            <form>
              <Form formData={this.state} colCount={4} labelLocation={"top"}>
                <SimpleItem dataField="fce" colSpan={3}>
                  <Label text="FCE" />
                </SimpleItem>
                <SimpleItem dataField="fceDecimais" colSpan={1}>
                  <Label text="Decimais" />
                </SimpleItem>
                <SimpleItem dataField="vve" colSpan={4}>
                  <Label text="VVE" />
                </SimpleItem>
                <SimpleItem dataField="fcl" colSpan={3}>
                  <Label text="FCL" />
                </SimpleItem>
                <SimpleItem dataField="fclDecimais" colSpan={1}>
                  <Label text="Decimais" />
                </SimpleItem>
                <SimpleItem dataField="vvt" colSpan={4}>
                  <Label text="VVT" />
                </SimpleItem>
                <SimpleItem dataField="vvi" colSpan={4}>
                  <Label text="VVI" />
                </SimpleItem>
                <SimpleItem
                  dataField="minimo"
                  colSpan={2}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}>
                  <Label text="Mínimo (R$)" />
                </SimpleItem>
                <SimpleItem dataField="maximo"
                  colSpan={2}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}>
                  <Label text="Máximo (R$)" />
                </SimpleItem>
              </Form>
            </form>
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "success",
              width: 150,
              onClick: () => this.setState({ _uiPopupParams: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </div>

    );
  }
}
